import ExpressionOperator from './ExpressionOperator';
import ExpressionProperty from './ExpressionProperty';
import ExpressionRoot from './ExpressionRoot';
import ExpressionValue from './ExpressionValue';

export const Expression = {
  Root: ExpressionRoot,
  Property: ExpressionProperty,
  Operator: ExpressionOperator,
  Value: ExpressionValue,
};
